import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <section id="home" className="hero-section">
      <div className="hero-content">
        <div className={`hero-text ${isVisible ? 'visible' : ''}`}>
          <h1 className="hero-title">Beleza Capilar Premium</h1>
          <div className="hero-divider"></div>
          <p className="hero-description">
            Compre direto da fábrica. Tecnologia italiana para cabelos perfeitos.
          </p>
          <Link to="/produtos" className="btn btn-warning btn-lg text-dark hero-cta">
            <i className="bi bi-bag me-2" aria-hidden="true"></i>
            Ver Produtos
          </Link>
        </div>
      </div>
      <div className="hero-scroll">
        <span>Scroll</span>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default Home;
